import { Typography as MaterialTypography } from '@mui/material';

function Typography({ children, className = '', ...props }) {
  return <MaterialTypography {...props}>{children}</MaterialTypography>;
}

export default Typography;
